export const Complements = [
  {
    code: 'IX0F',
    title: 'complements_IX0F_title',
    desc: 'complements_IX0F_desc',
    imgURL: './assets/img/IX0F.png',
    insideProps:['IX0A']
  },{
    code: 'IX02F',
    title: 'complements_IX0F_title',
    desc: 'complements_IX0F_desc',
    imgURL: './assets/img/IX02F.png',
    insideProps:['IX02A']
  },{
    code: 'IX02G',
    title: 'complements_IX0G_title',
    desc: 'complements_IX0G_desc',
    imgURL: './assets/img/IX02F.png',
    insideProps:['IX02B']
  }, {
    code: 'IX0G',
    title: 'complements_IX0G_title',
    desc: 'complements_IX0G_desc',
    imgURL: './assets/img/IX0G.png',
    insideProps:['IX0B']
  }, {
    code: 'IX0H',
    title: 'complements_IX0H_title',
    desc: 'complements_IX0H_desc',
    imgURL: './assets/img/IX0H.png',
    insideProps:['IX0A','IX0B']
  }, {
    code: 'IX02H',
    title: 'complements_IX0H_title',
    desc: 'complements_IX0H_desc',
    imgURL: './assets/img/IX02H.png',
    insideProps:['IX02A','IX02B']
  }, {
    code: 0,
    title: 'complements_0_title',
    desc: '',
    imgURL: '',
    alt: '',
    insideProps:['IX0A','IX02A','IX0B','IX02B']
  }
]
